const responseTypes = {
  DECLINED_CREDIT_ENROLLMENT: 'declinedCreditEnrollment',
  DECLINED_ENROLLMENT: 'declinedEnrollment',
  EMAIL_VERIFICATION_ATTEMPTS_EXCEEDED: 'check_email',
  INELIGIBLE_REWARDS_ENROLLMENT: 'ineligible',
  INVALID_DATA: 'invalidData',
  MANUAL_REVIEW: 'manual_review',
  NO_RESPONSE: 'noResponse',
  OUT_OF_WALLET: 'out_of_wallet',
  PENDING_REWARDS_ENROLLMENT: 'pending',
  PHONE_VERIFICATION_ATTEMPTS_EXCEEDED: 'check_phone',
  PREFILL_VARIANT_1: 'prefill_variant_1',
  REDIRECT: 'redirect',
  REDIRECT_TO_LOGIN: 'redirect_to_login',
  REDIRECT_TO_RECOVER: 'redirect_to_recover',
  SESSION_TIMEOUT: 'sessionTimeout',
  SUCCESS: 'success',
  SUCCESSFUL_CREDIT_ENROLLMENT: 'successfulCreditEnrollment',
  SUCCESSFUL_ENROLLMENT: 'successfulEnrollment',
  SUCCESSFUL_REWARDS_ENROLLMENT: 'active',
  USER_REVIEW: 'user_review',
  VERIFICATION_FAILED: 'verification_failed',
  VERIFY_EMAIL: 'verify_email',
  VERIFY_PHONE: 'verify_phone',
  ALREADY_HAS_ACTIVE_ACCOUNT: 'already_has_active_account',
  TAX_FILING_ENROLL: 'tax_filing_enroll',
};

export default responseTypes;

export function isValidCBRewardsResponse(response) {
  return (
    response === responseTypes.SUCCESSFUL_REWARDS_ENROLLMENT ||
    response === responseTypes.PENDING_REWARDS_ENROLLMENT ||
    response === responseTypes.INELIGIBLE_REWARDS_ENROLLMENT
  );
}
